module.exports = __webpack_public_path__ + "img/ilith_awaken.16b26a46.png";